import React from 'react';
import { Navigate } from 'react-router-dom';
import routes from 'src/constants/routes';

const Root: React.FC = () => {
  return <Navigate to={routes.main} replace={true} />;
};

export default Root;
